"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _Menu = _interopRequireDefault(require("../../Menu"));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var Item = function Item(_ref) {
  var value = _ref.value,
      selected = _ref.selected,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["value", "selected"]);
  return /*#__PURE__*/React.createElement(_Menu["default"].Item, (0, _extends2["default"])({}, props, {
    active: selected
  }));
};

var _default = Item;
exports["default"] = _default;
//# sourceMappingURL=Item.js.map